import {Grid} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import React from 'react'

import {ContentListItem} from 'src/api/cargo-c2c/types'
import {tagToUrl} from 'src/utils'

import {TextItem} from '../text-item'

type Props = {
  item: ContentListItem
}

const classes = {
  image: css`
    height: 24px;
  `,
  right: css`
    text-align: right;
  `,
}

export const ListItem: React.FC<Props> = ({item}) => {
  const {title, subtitle, trail_text: trailTitle, trail_subtitle: trailSubtitle, lead_icon: leadIcon} = item
  return (
    <Grid key={item.id} alignItems="center" direction="row" spacing={1} container>
      {leadIcon && (
        <Grid item>
          <Grid alignItems="center" container item>
            <img alt="" className={classes.image} loading="lazy" src={tagToUrl(leadIcon.image_tag)} />
          </Grid>
        </Grid>
      )}
      <Grid alignItems="center" justify="space-between" wrap="nowrap" container item xs>
        <Grid item>
          <TextItem item={title} />
          {subtitle && <TextItem item={subtitle} />}
        </Grid>
        {(trailTitle || trailSubtitle) && (
          <Grid className={classes.right} item>
            {trailTitle && <TextItem item={trailTitle} />}
            {trailSubtitle && <TextItem item={trailSubtitle} />}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}
